// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"016714d9","455":"8d124bdd","484":"8a53512e","918":"04375041","977":"d1f8b981"}[chunkId] + ".chunk.js";
};